export type JsonSchemaLike = {
    type?: string | string[];
    default?: unknown;
    properties?: Record<string, JsonSchemaLike>;
    items?: JsonSchemaLike;
    oneOf?: JsonSchemaLike[];
    anyOf?: JsonSchemaLike[];
    required?: string[];
};

function emptyForType(schema: JsonSchemaLike): unknown {
    if (schema.default !== undefined) {
        return schema.default;
    }
    const type = Array.isArray(schema.type) ? schema.type[0] : schema.type;
    switch (type) {
        case 'string':
            return '';
        case 'number':
        case 'integer':
            return 0;
        case 'boolean':
            return false;
        case 'null':
            return null;
        case 'array':
            return [];
        case 'object':
            return schemaEmpty(schema);
        default:
            if (schema.properties) {
                return schemaEmpty(schema);
            }
            if (schema.items) {
                return [];
            }
            return {};
    }
}

export function schemaEmpty(schema: JsonSchemaLike): Record<string, unknown> {
    if (!schema || typeof schema !== 'object') {
        return {};
    }
    const result: Record<string, unknown> = {};
    const properties = schema.properties;
    if (!properties) {
        return result;
    }
    for (const [key, propSchema] of Object.entries(properties)) {
        result[key] = emptyForType(propSchema ?? {});
    }
    return result;
}
